var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showTopBar
    ? _c("div", { staticClass: "topBar" }, [_c("p", [_vm._v("BETA")])])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }